import { defineRule, configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import AllRules from '@vee-validate/rules'

Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule])
})

configure({
  generateMessage: localize('fr', {
    messages: {
      required: 'Le champ est requis.',
      email: "Cette adresse mail n'est pas valide.",
      max : 'Maximum {length} caractères.',
      min : 'Le code postal est trop court.',
    }
  })
})
